var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAdd = function SvgAdd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6a6 6 0 1 1 12 0A6 6 0 1 1 0 6Z",
    fill: "#2F5EA7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.4 3.372a.4.4 0 0 0-.8 0V5.6H3.372a.4.4 0 0 0 0 .8H5.6v2.228a.4.4 0 1 0 .8 0V6.4h2.228a.4.4 0 1 0 0-.8H6.4V3.372Z",
    fill: "#fff"
  })));
};
export default SvgAdd;